import { registerI18nBundle } from '@cyberint/common-utils';
import resources from './trans-resources';

const NAMESPACE = 'alerts';

registerI18nBundle({
  namespace: NAMESPACE,
  en: resources,
  loaders: {
    es: () => import(/* webpackChunkName: "common-alerts-i18n-locale-es" */ './trans-locales/es'),
    fil: () => import(/* webpackChunkName: "common-alerts-i18n-locale-fil" */ './trans-locales/fil'),
    ja: () => import(/* webpackChunkName: "common-alerts-i18n-locale-ja" */ './trans-locales/ja'),
    th: () => import(/* webpackChunkName: "common-alerts-i18n-locale-th" */ './trans-locales/th')
  }
});
